import { render, staticRenderFns } from "./CatalogProductVatProfilesList.vue?vue&type=template&id=60ceaf6f&scoped=true&"
import script from "./CatalogProductVatProfilesList.vue?vue&type=script&lang=js&"
export * from "./CatalogProductVatProfilesList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductVatProfilesList.vue?vue&type=style&index=0&id=60ceaf6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ceaf6f",
  null
  
)

export default component.exports